export default {
  "content": "<path d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 101.386-4.5H8v2H3a1 1 0 01-1-1v-5h2v2.499A9.985 9.985 0 0112 2z\" fill=\"#7B61FF\"/><path d=\"M12.5 12h3v2h-4a1 1 0 01-1-1V8h2v4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};